import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { List } from 'nallian-shared-ui/lib/components';

const ListContent = styled(List.Content)`
  display: flex;
  margin-bottom: 0.6rem;
  padding-bottom: 0.8rem;
  border-bottom: 1px solid rgba(34, 36, 38, 0.15);

  &:last-child {
    margin-bottom: 0;
    padding-bottom: 0;
    border-bottom: 0px solid transparent;
  }

  && .header {
    width: 12rem;
  }
`;

const IdentificationCodes = ({ communityMemberFetch }) => {
  return (
    <List relaxed divided>
      {(communityMemberFetch.value?.identificationCodes || []).map(idcode => (
        <List.Item>
          <ListContent>
            <List.Header>{idcode.type?.name}:</List.Header>
            <List.Description>{idcode?.value}</List.Description>
          </ListContent>
        </List.Item>
      ))}
    </List>
  );
};

IdentificationCodes.propTypes = { communityMemberFetch: PropTypes.object.isRequired };

export default IdentificationCodes;
